import { render, staticRenderFns } from "./Soon.vue?vue&type=template&id=f03d2cb0"
import script from "./Soon.vue?vue&type=script&lang=js"
export * from "./Soon.vue?vue&type=script&lang=js"
import style0 from "./Soon.vue?vue&type=style&index=0&id=f03d2cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports